<template>
  <div class="assignment">
      <v-container class="mt-4">
          <v-layout column id="lay">
              <div id="note">
              <h1>New Notes</h1>
              <v-flex v-for="note in notes" :key="note.name">
                  <v-layout class="ml-8" row>
                      <v-btn width="250px" tile :elevation="1" :href="note.link" target="_blank" height="50px;"  class="mb-4"><div class="ml-2"><v-icon>attach_file</v-icon> {{note.name}}</div></v-btn>
                  </v-layout>
              </v-flex>
              </div>
          </v-layout>
      </v-container>
  </div>
</template>

<script>
import db from '../components/firebaseinit'

export default {
    data(){
        return {
            assigns:[
                {name:"Unit-4 Notes",type:"pdf"},
                {name:"Unit-3",type:"pptx"},
                {name:"Unit-2",type:"pdf"},
                {name:"Unit-4 Assignment",type:"pdf"}
            ],
            notes:[]
        }
    },
    methods:{

    },
    beforeMount(){
        console.log(this.$route.params.id)
        db.collection('notes').get().then(doc => {
            console.log(doc.docs)
            doc.docs.forEach(arr => {
                console.log(arr.data())
                if(arr.data().Sub===this.$route.params.id){
                    this.notes.push({name:arr.data().Name,link:arr.data().qlink})
                    // console.log(arr.Name)
                }
            })
            console.log(this.notes)
        })
    }
}
</script>


<style scoped>
#lay{
    border:3px solid black;
    /* border-radius: 20%; */
    margin-bottom: 30px;
}
#note{
    padding-left: 200px;
}
</style>